<template>
    <div>
        <div class="page page--checkout">
            <div class="h-container-checkout">
                <header class="page__heading page__heading--first">
                    <h1 class="page__heading-title h2">
                        <AppIcon modifier="cartheader"/>
                        Order Confirmation
                    </h1>
                </header>
            </div>
            <div class="h-container-checkout-a">
                <div class="h-checkout-grid">
                    <div class="h-checkout-left-col">
                        <OrderConfirmation/>
                    </div>
                    <div class="h-checkout-right-col">
                        <aside class="text h-sticky">
                            <OrderAccountManager/>
                            <CartCertificates/>
                        </aside>
                    </div>
                </div>
            </div><!-- /.h-container -->
            <div class="page__block page__block--a">
                <div class="h-container-checkout">
                    <div class="grid">
                        <div class="grid__col--sm-6 grid__col--md-4">
                            <div class="text">
                                <h6>Frequently asked questions</h6>
                                <FaqAccordion/>
                            </div>
                        </div>
                        <div class="grid__col--sm-6 grid__col--md-4">
                            <CartBenefits/>
                        </div>
                    </div>
                    <a href="#" class="page__misc-back-btn">
                        <AppIcon modifier="arrow" class="page__misc-back-btn-icon"/>
                        Back to Start
                    </a>
                </div>
            </div>
        </div><!-- /.page-container -->
    </div>
</template>

<script>
import OrderConfirmation from '../../components/cart/OrderConfirmation';
import AppIcon from '../../components/AppIcon';
import FaqAccordion from '../../components/FaqAccordion';
import CartBenefits from '../../components/cart/CartBenefits';
import CartCertificates from '../../components/cart/CartCertificates';
import OrderAccountManager from '../../components/orders/OrderAccountManager';

export default {
  components: {
    CartBenefits,
    CartCertificates,
    AppIcon,
    FaqAccordion,
    OrderConfirmation,
    OrderAccountManager,
  },
};
</script>
